import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  resourceDocTitle: {
    description: 'Small block title',
    defaultMessage: 'Read the Developer Docs',
    id: 'wfxHoZ',
  },
  resourceDocText: {
    description: 'Small block content for Documentation section',
    defaultMessage: 'See our developer guides to get started and full API reference for endpoint details.',
    id: 'GEcbSx',
  },
  resourceHelpText: {
    description: 'Small block content for Help section',
    defaultMessage: 'Contact our API support team for questions or issues using our API.',
    id: 'ddwWIV',
  },
  resourceDocLink: {
    description: 'Button title',
    defaultMessage: 'Go to documentation',
    id: 'qzUZmZ',
  },
  resourceHelpTitle: {
    description: 'Small block title',
    defaultMessage: 'Need help?',
    id: 'nlDdra',
  },
  resourceHelpLink: {
    description: 'Button title',
    defaultMessage: 'Contact API support',
    id: 'XHoOrB',
  },
  resources: {
    description: 'Section title',
    defaultMessage: 'Resources',
    id: 'EtkedH',
  },
});
